import { cn } from "@/src/lib/utils";
import { forwardRef, useMemo } from "react";

export const Footer = forwardRef<HTMLElement, { className?: string }>((props, ref) => {
  const className = cn("flex w-full justify-center items-center mt-6", props.className);
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  return (
    <footer ref={ref} className={className}>
      <span>© {currentYear} Helm</span>
    </footer>
  );
});
